import type { ChainSocials } from '#lib/constants/chainsSocials.js'

import { phg } from './posthog'

type GetListedDialogProps = {
	open: boolean
	chainName?: string
	chainSocials?: ChainSocials
}

export const getListedDialog = $state<GetListedDialogProps>({ open: false })

export const updateGetListedDialog = ({ open, chainName, chainSocials }: GetListedDialogProps) => {
	getListedDialog.open = open
	getListedDialog.chainName = chainName
	getListedDialog.chainSocials = chainSocials
}

export type MetricDialogProps = {
	open: boolean
	metric: Nullable<
		| 'tps'
		| 'max_tps'
		| 'theor_tps'
		| 'blocktime'
		| 'ttf'
		| 'governance'
		| 'launch_date_age'
		| 'txns'
		| 'total_txns'
		| 'nc'
		| 'stake_or_hashrate'
		| 'hashrate'
		| 'stake'
		| 'validators_or_miners'
		| 'validators'
		| 'miners'
		| 'consensus'
		| 'repos'
		| 'stars'
		| 'watchers'
		| 'commits'
		| 'developers'
		| 'revenue'
		| 'price'
		| 'market_cap'
		| 'avg_tx_fee'
		| 'fdv'
		| 'market_cap_to_fdv'
		| 'agent_services'
		| 'agent_x402'
		| 'agent_owner'
		| 'services_n'
		| 'card'
		| 'card_cashback'
		| 'card_fx_fee'
		| 'card_kyc'
		| 'card_borrowing'
		| 'card_launched'
		| 'card_annual_fee'
		| 'card_volume'
		| 'card_txns'
		| 'card_users'
		| 'card_total_volume'
		| 'card_total_txns'
		| 'card_total_users'
	>
}

export const metricDialog = $state<MetricDialogProps>({ open: false, metric: null })

export const updateMetricDialog = ({ open, metric }: MetricDialogProps) => {
	metricDialog.open = open
	metricDialog.metric = metric
}

type MobileMenuProps = {
	open: boolean
	anchor: Nullable<HTMLElement>
}

export const mobileMenu = $state<MobileMenuProps>({ open: false, anchor: null })

export const updateMobileMenu = (
	open: MobileMenuProps['open'],
	anchor?: MobileMenuProps['anchor']
) => {
	mobileMenu.open = open

	if (anchor) {
		mobileMenu.anchor = anchor
	}
}

type SearchDialogProps = {
	open: boolean
}

export const searchDialog = $state<SearchDialogProps>({ open: false })

export const updateSearchDialog = (open: SearchDialogProps['open']) => {
	searchDialog.open = open

	if (open) phg.capture('search_dialog_open')
}
